module.exports = __webpack_public_path__ + "static/media/clima.218e5171.jpg";